import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initSentry, ErrorBoundary } from "@/lib/observability";

initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<FallbackUI />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

function FallbackUI() {
  return (
    <div
      data-testid="kidhq-error-boundary"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FAF5EE",
        color: "#1E1F1B",
        fontFamily: "Inter, system-ui, sans-serif",
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 480, textAlign: "center" }}>
        <h1 style={{ fontSize: 28, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ opacity: 0.8, marginBottom: 20 }}>
          KidHQ hit an unexpected error. We&apos;ve been notified and are looking into it.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: "#16271F",
            color: "white",
            padding: "10px 18px",
            borderRadius: 12,
            border: "none",
            cursor: "pointer",
          }}
        >
          Reload KidHQ
        </button>
      </div>
    </div>
  );
}
